export const UserFunctionsTypesList = [
  { name: 'Scala', value: 'scala' },
  { name: 'Python', value: 'python' },
];
